import { gyromagneticRatioMHzT } from './gyromagneticRatioMHzT';
export const gyromagneticRatio = Object.fromEntries(Object.entries(gyromagneticRatioMHzT).map(([key, value]) => [
    key,
    value * 2 * Math.PI * 1e6,
]));
export * from './gyromagneticRatioMHzT';
export * from './getGyromagneticNucleus';
export * from './getGyromagneticRatio';
//# sourceMappingURL=index.js.map